export default __webpack_public_path__ + "static/media/type_4_8.958b1299.svg";